import { Controller } from 'stimulus';

// Toolbar dropdown that drives the hidden "roles" column's checkbox filter
// on the guides Tabulator table. Each checkbox maps to a translated role
// label; checking/unchecking dispatches a `tabulator-table:set-external-filter`
// event that the table controller picks up generically.
export default class extends Controller {
  static targets = ['checkbox', 'toggle', 'icon'];

  connect() {
    this._onClear = () => this.reset();
    const table = document.querySelector(
      '[data-controller~="tabulator-table"]'
    );
    if (table) {
      table.addEventListener('tabulator-table:cleared', this._onClear);
      this._table = table;
    }
  }

  disconnect() {
    if (this._table && this._onClear) {
      this._table.removeEventListener('tabulator-table:cleared', this._onClear);
    }
    this._table = null;
    this._onClear = null;
  }

  apply() {
    // Delay one frame so checkbox-bulk-actions' checkAll/clearAll toggles
    // land before we read the checked set.
    requestAnimationFrame(() => {
      this._dispatchFilter();
      this._updateToggleStyle();
    });
  }

  reset() {
    this.checkboxTargets.forEach((cb) => (cb.checked = true));
    this._updateToggleStyle();
  }

  _dispatchFilter() {
    const allOptions = this.checkboxTargets.map((cb) => cb.value);
    const checkedValues = new Set(
      this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
    );

    const table =
      this._table ||
      document.querySelector('[data-controller~="tabulator-table"]');
    if (!table) return;

    table.dispatchEvent(
      new CustomEvent('tabulator-table:set-external-filter', {
        detail: {
          field: 'roles',
          kind: 'checkbox',
          criteria: {
            kind: 'checkbox',
            checkedValues,
            allOptions,
            multiValue: true,
          },
        },
      })
    );
  }

  _updateToggleStyle() {
    const allChecked = this.checkboxTargets.every((cb) => cb.checked);
    if (this.hasToggleTarget) {
      this.toggleTarget.classList.toggle('border-primary', !allChecked);
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('text-muted', allChecked);
      this.iconTarget.classList.toggle('text-primary', !allChecked);
    }
  }
}
